import React from 'react';

const WitnessBlock = (props)=>{
    return(
        <div>
            <div>
                Signed in the presence of:
            </div>
            <table className="table-even mt-5">
                <tbody>
                    <tr>
                        <td className="text-center">
                            <div className="blank-line-long"></div>
                        </td>
                        <td className="text-center">
                            <div className="blank-line-long"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default WitnessBlock;


// WEBPACK FOOTER //
// ./src/view/WitnessBlock.js